import { sub } from "date-fns";
import { getCurrentTimestamp } from "../dateProvider";

const MIN_AGE = 18;

export const minAgeThresholdDate = () => sub(getCurrentTimestamp(), { years: MIN_AGE });
